export enum PaymentStatusEnum {
    Awaiting = 'Awaiting',
    Received = 'Received',
    Invoiced = 'Invoiced',
    Cancelled = 'Cancelled',
}
export enum PaymentStatus {
    Awaiting = 1,
    Received,
    Invoiced,
    Cancelled,
}

export const paymentStatusEnumTranslationsPl = {
    Awaiting: 'Oczekująca',
    Received: 'Otrzymana',
    Invoiced: 'Wystawiona faktura',
    Cancelled: 'Anulowana',
};

export const paymentStatusEnumTranslationsEn = {
    Awaiting: 'Awaiting',
    Received: 'Received',
    Invoiced: 'Invoiced',
    Cancelled: 'Cancelled',
};

export const mapPaymentStatusToApiModel = (internalModel?: PaymentStatusEnum): PaymentStatus | undefined => {
    switch (internalModel) {
        case PaymentStatusEnum.Awaiting:
            return PaymentStatus.Awaiting;
        case PaymentStatusEnum.Received:
            return PaymentStatus.Received;
        case PaymentStatusEnum.Invoiced:
            return PaymentStatus.Invoiced;
        case PaymentStatusEnum.Cancelled:
            return PaymentStatus.Cancelled;
        default:
            return undefined;
    }
};
